var scope_0 = require('/home/runner/work/commercetools-docs/commercetools-docs/websites/tutorials/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a5819ca198bed135c68fd86240580a79.js').default;
var scope_1 = require('/home/runner/work/commercetools-docs/commercetools-docs/websites/tutorials/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    